import React, { useEffect, useState } from 'react';
import {ArrowLeftOutlined} from '@ant-design/icons';
import {Divider, Button} from 'antd';
import {DIR_RTL} from "../../../constants/ThemeConstant";
import {useSelector, useDispatch} from "react-redux";
import {useHistory} from 'react-router-dom';
import { APP_PREFIX_PATH } from "configs/AppConfig";
import { getOrderCheckStatus, updateDataState } from 'redux/actions';
import "./style.css";

function OrderStatus() {
    const {direction} = useSelector((state => state.theme));
    const {orderCheckStatus, orderCheckStatusLoading} = useSelector(state => state.fetchedData);
    const [values, setValues] = useState({code: '', phone: ''});
    const dispatch = useDispatch();
    const history = useHistory();

    const submit = () => { 
        if (values.code && values.phone) {
            // history.push(`${APP_PREFIX_PATH}/checkOutFour?code=${values.code}&phone=${values.phone}`);
            dispatch(getOrderCheckStatus(`?code=${values.code}&phone=${values.phone}`));
        }
    }
 
    useEffect(()=>{
        window.scrollTo({top:0, behavior: 'auto'});
    }, []);

    useEffect(() => {
        if (orderCheckStatus?.orderId === values?.code) {
            dispatch(updateDataState({orderCheckStatus: {}}));
            history.push(`${APP_PREFIX_PATH}/checkOutFour?code=${values.code}&phone=${values.phone}`)
        }
    }, [orderCheckStatus])

 
    return (
        <div className={'h-100 position-relative'}>
            <div className='relative d-flex align-items-center p-3'>
                <div onClick={() => {
                    window.history.back();
                }} style={{position: 'absolute'}}>
                    <ArrowLeftOutlined rotate={direction === DIR_RTL ? 180 : 0} style={{fontSize: '24px', cursor: 'pointer', color: 'black'}}/>
                </div>
                <div className='text-center w-100' style={{fontSize: "16px", color: '#000', fontWeight: '600'}}>Order Look Up</div>
            </div>
            <Divider className='mt-0 mb-0'/>
            <div className={"p-3 mt-3 order-status-form"}>
                <p style={{fontSize: "15px"}}> Order code can be found in SMS messages, after placing an order. </p>
                <div className={'checkOut-form mt-5 p-0'}>
                    <div className={'checkOut-form-item'}>
                        <input type="text" onChange={(e) => setValues((prev) => ({...prev, code: e.target.value}))} value={values?.code}/>
                        <label className='labelName'>
                            <span className={`${values?.code ? "select-content-name" : ""} content-name`}>Order code</span>
                        </label>
                    </div>
                    <div className={'checkOut-form-item'}>
                        <input type="number" onChange={(e) => setValues((prev) => ({...prev, phone: e.target.value}))} value={values?.phone}/>
                        <label className='labelName'>
                            <span className={`${values?.phone ? "select-content-name" : ""} content-name`}>Phone</span>
                        </label>
                    </div>
                </div>
            </div>
            <div className='order-status-btn branch-btn'>
                <Button onClick={submit} loading={orderCheckStatusLoading} className={`w-100 orderCheckout btn-project primaryColor`} style={{color:'white'}}>
                    Look Up Order
                </Button>
            </div>
        </div>
    );
}

export default OrderStatus;